import React, {useContext} from "react";
import PropTypes from "prop-types";
import {localhost} from "../../env";
import spotGroupIcon from "../../assets/icons/spot-group.svg";
import arrowSimpleRight from "../../assets/icons/arrow-simple-right.svg";
import standIcon from "../../assets/icons/stand.svg";
// import Button from "../Button/Button";
// import companyIcon from "../../assets/icons/company.svg";
import BookingActions from "../BookingActions/BookingActions";
import useFunction from "../../hooks/useFunction";
import useBooking from "../../hooks/useBooking";
import usePrice from "../../hooks/usePrice";
// import "./style.scss"
import BookingBookableProfileLinks from "../BookingBookableProfileLinks/BookingBookableProfileLinks";
import swal from "sweetalert";
import Button from "../Button/Button";
import useUserService from "../../api/services/useUserService";
import AuthContext from "../../context/AuthContext";


const BookingItemAdmin = ({booking, callbackConfirm, showForAdmin = false}) => {

  const {date, dateTime} = useFunction()
  const {getBookingStatusLabel, getBookingActionLabel} = useBooking()

  const {
    formatPrice,
    // getBookingPriceTotalWithoutFeeAndOptions,
    // getBookingOptionsTotalPrice,
    // getBookable,
    // getBookingFeeAndTransactionFee,
    // getBookingPriceTotal,
    // getBookingPriceTotalWithoutFee,
    // addBookingFee,
    // isPositivePrice: isPositivePriceFunc,
    transactionFee,
  } = usePrice()

  const {userSwitchActiveCompany} = useUserService();
  const {user} = useContext(AuthContext)

  const getClassname = () => {
    let className = "component-booking-item booking-status-" + booking.status
    className += (booking.needs_action) ? ' needs-action ' : ''
    return className
  }

  const switchActiveCompany = (companyId) => {
      swal({
          title: "Aan het schakelen...",
          text: "Een moment geduld",
          icon: "info",
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
      });
      userSwitchActiveCompany(
          () => {
              // swal.close();
              swal({
                  title: "Geswitched",
                  icon: "success",
                  timer: 1000,
                  buttons: false,
              });
          },
          () => {
              // swal.close();
              swal({
                  title: "Er ging iets mis",
                  text: "Probeer het opnieuw",
                  icon: "error",
                  timer: 1000,
                  buttons: false,
              });
          },
          companyId
      );
  }

  return (
    <div className={getClassname()}>
      <div className="fields">
        <div className="field id">
          <p className={"label"}>ID:</p>
          <p>{booking.booking_number}</p>
          {localhost && <p>ID: {booking.id}</p>}
        </div>
        <div className="field status">
          <p className={"label"}>Status:</p>
          <h4>
            {getBookingStatusLabel(booking.status)}
            {booking.updated_after_request_at && booking.status === 'requested'
              && <span className="meta"> (geupdate)</span>
            }
          </h4>
          <h4>
            {booking.status === 'concept' && <>Nog af te maken</>}
            {(booking.status === 'requested' || booking.status === 'accepted') &&
              <>
                {booking.needs_action ? getBookingActionLabel(booking.needs_action) : 'Wachten op tegenpartij'}
              </>
            }
            {booking.status === "pay-after" && <>Gepland! {booking.active_user_pays && 'achteraf betalen'}</>}
            {booking.status === 'paid' && <>Gepland!</>}
          </h4>
          <p className={"label"}>Richting:</p>
          <p>{(booking.direction === 'receiving') ? 'Inkomend' : 'Uitgaand'}</p>
          {(booking.type === 'spot-group-requests-stand') &&
            <div className="row">
              <img width={22} src={spotGroupIcon} alt="Locatie"/>
              <img width={22} src={arrowSimpleRight} alt="->"/>
              <img width={22} src={standIcon} alt="Stand / Truck"/>
            </div>
          }
          {(booking.type === 'stand-requests-spot') &&
            <div className="row">
              <img width={22} src={standIcon} alt="Stand / Truck"/>
              <img width={22} src={arrowSimpleRight} alt="->"/>
              <img width={22} src={spotGroupIcon} alt="Locatie"/>
            </div>
          }
        </div>

        <div className="field dates">
          <p className={"label"}>Data: </p>
          {booking.date_ranges && !!booking.date_ranges.length && booking.date_ranges.map((dateRange, i) => {
            return (
              <div key={i}>
                {dateRange.end_date ?
                  <p>{date(dateRange.start_date)} <span
                    className="meta">t/m</span> {date(dateRange.end_date)}</p>
                  :
                  <p>{date(dateRange.start_date)}</p>
                }
              </div>
            )
          })}
        </div>

        {'spots' in booking && booking.spots && !!booking.spots.length &&
          <div className="field spots">
            <p className="label">Spots:</p>
            <div className="spots-container">
              {booking.spots.map((spot, i) => {
                if (spot.spot_cluster) {
                  return (<div key={i}>{spot.spot_cluster.label}: {spot.label}</div>)
                } else {
                  return (<div key={i}>{spot.label}</div>)
                }
              })}
            </div>
              <br/>
              <p className="label">Companies:</p>
              <p className="label">Requested by:</p>
              <Button
                label={booking.requested_by_company.legal_name}
                size="xs"
                color="blue-ghost"
                disabled={(user.active_company_id === booking.requested_by_company_id)}
                onClick={() => switchActiveCompany(booking.requested_by_company_id)}
              />
              <p className="label">Received by:</p>
              <Button
                  label={booking.received_by_company.legal_name}
                  size="xs"
                  color="blue-ghost"
                  disabled={(user.active_company_id === booking.received_by_company_id)}
                  onClick={() => switchActiveCompany(booking.received_by_company_id)}
              />
          </div>
        }

        <div className="field options">
          <p className="label">Opties:</p>
          {booking.booking_options && !!booking.booking_options.length && booking.booking_options.map((option, i) => {


            //todo deze Opties worden nu niet weergegeven (oud script?)


            return (
              <div key={i}>
                <p>{option.bookable_option.label}</p>
              </div>
            )
          })}
        </div>

        {(booking.status === 'concept') ?
          <>
          </>
          :
          <>
            {((booking.direction === 'receiving' && booking.prices) || showForAdmin) &&
              <div className="field price">
                <h5>
                  {booking.prices.totals.receiving.total.get ? 'Inkomsten: ' : 'Uitgaven: '}
                  {showForAdmin && booking.received_by_company.legal_name}
                </h5>
                {booking.prices.totals.receiving.get.rent
                  ? <p>Verhuur inkomsten: {formatPrice(booking.prices.totals.receiving.get.rent)}</p>
                  : <p>Huur kosten: {formatPrice(booking.prices.totals.receiving.pay.rent)}</p>
                }
                <p>Opties inkomsten: {formatPrice(booking.prices.totals.receiving.get.options)}</p>
                {booking.prices.totals.receiving.total.get
                  ? <p>Totale inkomsten (ex. BTW): {formatPrice(booking.prices.totals.receiving.total.get)}</p>
                  : <p>Totale uitgaven (ex. BTW): {formatPrice(booking.prices.totals.receiving.total.pay)}</p>
                }
              </div>
            }
            {((booking.direction === 'requesting' && booking.prices) || showForAdmin) &&
              <div className="field price">
                <h5>
                  {booking.prices.totals.requesting.total.get ? 'Inkomsten: ' : 'Uitgaven: '}
                  {showForAdmin && booking.requested_by_company.legal_name}
                </h5>
                {booking.prices.totals.requesting.get.rent
                  ? <p>Verhuur inkomsten: {formatPrice(booking.prices.totals.requesting.get.rent)}</p>
                  : <p>Huur kosten: {formatPrice(booking.prices.totals.requesting.pay.rent)}</p>
                }
                <p>Opties kosten: {formatPrice(booking.prices.totals.requesting.pay.options)}</p>
                <p>{(booking.prices.totals.requesting.pay.fees >= transactionFee) ? 'Boekingskosten:' : 'Fee & Boekingskosten:'} {formatPrice(booking.prices.totals.requesting.pay.fees)}</p>
                {booking.prices.totals.requesting.total.get
                  ? <p>Totale inkomsten (ex. BTW): {formatPrice(booking.prices.totals.requesting.total.get)}</p>
                  : <p>Totale uitgaven (ex. BTW): {formatPrice(booking.prices.totals.requesting.total.pay)}</p>
                }
              </div>
            }
          </>
        }

        <BookingBookableProfileLinks
          booking={booking}
          buttonSize="xs"
        />

        <div className="field meta">
          <p className={"label"}>Aangevraagd:</p>
          <p>{dateTime(booking.created_at)}</p>
          {booking.updated_at !== null && booking.updated_at !== booking.created_at &&
            <>
              <p className={"label"}> Geupdate:</p>
              <p>{dateTime(booking.updated_at)}</p>
            </>
          }
        </div>
        {!showForAdmin &&
          <div className="field actions">
            <BookingActions booking={booking} callbackConfirm={callbackConfirm}/>
          </div>
        }
        {(booking.deny_reason_requested_company || booking.deny_reason_received_company) &&
          <div className="field deny-reasons">
            <p className={'label'}>Opgegeven rede tot afwijzing:</p>
            {booking.deny_reason_requested_company}
            {booking.deny_reason_received_company}
          </div>
        }
      </div>
    </div>
  )
}

BookingItemAdmin.propTypes = {
  booking: PropTypes.object.isRequired,
  callbackConfirm: PropTypes.func.isRequired,
  showForAdmin: PropTypes.bool,
}

export default BookingItemAdmin